import { Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'confirmacao',
  templateUrl: './confirmacao.component.html',
  styleUrls: ['./confirmacao.component.scss'],
})
export class ConfirmacaoComponent extends ModalDirective {

  @Input() titulo: string = "Confirmação";
  @Input() mensagem: string = "";

  @Input() textoBotaoConfirmar: string = "Confirmar";
  @Input() textoBotaoCancelar: string = "Cancelar";

  @Output() confirmar = new EventEmitter();
  @Output() cancelar = new EventEmitter();

  @Input() objetoAlvo: any;

  @ViewChild('modalConfirmacao')
	modalConfirmacao: ModalDirective;

  onConfirmar() {
    this.confirmar.emit(this.objetoAlvo);
    this.modalConfirmacao.hide();
  }

  onCancelar() {
    this.cancelar.emit(this.objetoAlvo);
    this.modalConfirmacao.hide();
  }

  show(objetoAlvo?: any) {
    this.objetoAlvo = objetoAlvo;
    this.modalConfirmacao.show();
  }
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/confirmacao/confirmacao.component.ts